/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const DELETE_DAI_GROUP = gql`
  mutation DeleteDaiGroup($id: ID!) {
    deleteDaiGroup(id: $id)
  }
`
